import { useEffect, useMemo, useState } from 'react'
import { isMultiCartFlightItem } from 'components/Pages/UserCartPage/SharedCarts/multiCartUtils'
import { isFlightItem } from 'lib/checkout/checkoutUtils'

const FLIGHT_CART_EXPIRY_TICK_MS = 1000

function hasActiveFlightExpiry(cartItemsMap: Map<string, App.MultiCartItem>): boolean {
  for (const cartItem of cartItemsMap.values()) {
    if (!isMultiCartFlightItem(cartItem)) continue
    if (!isFlightItem(cartItem.item)) continue
    if (cartItem.state === 'deleted') continue
    if (cartItem.item.expiry !== undefined && cartItem.item.expiry > Date.now()) return true
  }

  return false
}

export function useFlightCartExpiryTick(cartItemsMap: Map<string, App.MultiCartItem>): number {
  const [now, setNow] = useState(Date.now)
  const shouldTick = useMemo(() => hasActiveFlightExpiry(cartItemsMap), [cartItemsMap])

  useEffect(() => {
    setNow(Date.now())
    if (!shouldTick) return

    const interval = setInterval(() => {
      setNow(Date.now())
    }, FLIGHT_CART_EXPIRY_TICK_MS)

    return () => clearInterval(interval)
  }, [shouldTick])

  return now
}
